import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator";
/** @internal */ export const pointerValidator = T.model("pointer", T.object({
    typeName: T.literal("pointer"),
    id: idValidator("pointer"),
    x: T.number,
    y: T.number,
    lastActivityTimestamp: T.number,
    meta: T.jsonValue
}));
/** @internal */ export const pointerVersions = {
    AddMeta: 1
};
/** @internal */ export const pointerMigrations = defineMigrations({
    currentVersion: pointerVersions.AddMeta,
    migrators: {
        [pointerVersions.AddMeta]: {
            up: (record)=>{
                return {
                    ...record,
                    meta: {}
                };
            },
            down: ({ meta: _, ...record })=>{
                return {
                    ...record
                };
            }
        }
    }
});
/** @public */ export const PointerRecordType = createRecordType("pointer", {
    validator: pointerValidator,
    migrations: pointerMigrations,
    scope: "session"
}).withDefaultProperties(()=>({
        x: 0,
        y: 0,
        lastActivityTimestamp: 0,
        meta: {}
    }));
/** @public */ export const TLPOINTER_ID = PointerRecordType.createId("pointer");
